export function isProductOrderable(product) {
	//No Web Ordering
	if (product.web_ordering === false) {
		return false;
	}

	//Out of Stock
	if (product.in_stock === false) {
		if (product.no_backorders === true) {
			return false;
		}
	}
	return true;
}
export function availableTextHasDays(available_text) {
	if (!available_text) {
		return false;
	}
	return available_text.toLowerCase().includes('days');
}
export function availableTextHasPlus(available_text) {
	if (!available_text) {
		return false;
	}
	return available_text.includes('+');
}
export function getStockMessageData(product_matches) {
	// More than one match, no message
	if (product_matches.length > 1) {
		return null;
	}

	// No matches, unavailable
	if (product_matches.length === 0) {
		return {
			messageType: 'Unavailable',
			messageStatus: 'Invalid',
		};
	}

	let product = product_matches[0];

	//Not Purchaseable (in category ALLPROMO)
	if (product.not_purchaseable === true) {
		return {
			messageType: 'NotPurchaseable',
			messageStatus: 'LowStock',
		};
	}

	if (product.in_store_only === true) {
		return {
			messageType: 'InStoreOnly',
			messageStatus: 'LowStock',
		};
	}

	//No Web Ordering
	if (product.web_ordering === false) {
		if (product.preorder === true) {
			return {
				messageType: 'PreRelease',
				availableText: product.available_text,
			};
		}

		if (product.in_stock === true) {
			return {
				messageType: 'NoWebOrdering',
				messageStatus: 'Invalid',
			};
		}

		return {
			messageType: 'OutOfStock',
			messageStatus: 'Invalid',
		};
	}

	//Drop Ship
	if (product.drop_shipped === true) {
		if (product.in_stock === true) {
		return null;
		}
		if (product.no_backorders === true) {
		return {
			messageType: "NoBackorder",
			messageStatus: "Backorder",
			availableText: product.available_text,
			showRestockDate: true
		};
		}

		return {
		messageType: "Backorder",
		messageStatus: "Backorder",
		availableText: product.available_text,
		};
	}

  	//Out of Stock
  	if (product.in_stock === false) {
		if (product.no_backorders === true) {
		return {
			messageType: "NoBackorder",
			messageStatus: "Backorder",
			availableText: product.available_text,
			notifyStock: product.stock_notify,
			notifyCode: product.code
		};
		}
		if (availableTextHasDays(product.available_text)) {
			return {
				messageType: 'Backorder',
				messageStatus: 'Backorder',
				availableText: product.available_text,
			};
		}

		if (product.preorder === true) {
			return {
				messageType: 'PreOrder',
				messageStatus: 'Backorder',
				availableText: product.available_text,
				notifyStock: product.stock_notify,
				notifyCode: product.code,
			};
		}
		return {
			messageType: 'Backorder',
			messageStatus: 'Backorder',
			availableText: product.available_text,
			notifyStock: product.stock_notify,
			notifyCode: product.code,
		};
	}

	//Not Drop Shipped and has definite quantity (XX in stock)
	if (product.web_stock === true && product.drop_shipped === false && !availableTextHasPlus(product.available_text)) {
		return {
			messageType: 'Available',
			messageStatus: 'LowStock',
			availableText: product.available_text,
		};
	}
	return null;
}

/**
 * Function to decode a string from html entities
 * @param {String} myStr
 * @returns
 */
export function decodeHtmlEntities(string_to_decode) {
	let returnString = string_to_decode;
	if (returnString) {
		let txtElement = document.createElement('textarea');

		txtElement.innerHTML = returnString;
		returnString = txtElement.value.replace(/&#(\d+);/gm, (match, dec) => `${String.fromCharCode(dec)}`);
	}
	return returnString;
}
